import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { signIn as sendSignInRequest, refreshSession } from '../api/auth';
import { clearAuthData } from './GenericFunctions';
import type { User, AuthContextType } from '../types';

function AuthProvider(props: React.PropsWithChildren<unknown>) {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      try {
        const storedUserId = localStorage.getItem('user_id');
        if (storedUserId && storedUserId !== 'undefined') {
          const result = await refreshSession(storedUserId);
          if (result.isOk && result.data) {
            setUser(result.data);
          }
        }
      } catch (error) {
        console.error('No fue posible restaurar la sesión del usuario.', error);
      }
      setLoading(false);
    })();
  }, []);
  const signIn = useCallback(async (email: string, password: string) => {
    const result = await sendSignInRequest(email, password);
    if (result.isOk) {
      setUser(result.data);
    }
    return result;
  }, []);
  const signOut = useCallback(() => {
    setUser(undefined);
    try {
      localStorage.removeItem('user_id');
    } catch (error) {
      console.error('No fue posible eliminar el identificador de usuario almacenado.', error);
    }
    clearAuthData();
    if (typeof document !== 'undefined') {
      document.cookie = 'dtUsuario=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
    }
  }, []);
  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading }} {...props} />
  );
}
const AuthContext = createContext<AuthContextType>({ loading: false } as AuthContextType);
const useAuth = () => useContext(AuthContext);
export { AuthProvider, useAuth }